import React from 'react';

import { Product } from '../..';
import {
  fundsAvailableProductsFiltersQuery,
  fundsAvailableProductsQuery,
} from '../../../../../../../../store/availableProducts/selectors';

import { FundsListItem } from './ListItem';
import { ListLoadingItem } from './ListLoadingItem';

export const FundsProduct = () => {
  return (
    <Product
      productsQuery={fundsAvailableProductsQuery}
      customFiltersQuery={fundsAvailableProductsFiltersQuery}
      ProductItem={FundsListItem}
      ProductItemLoading={ListLoadingItem}
    />
  );
};
